"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroupItem = void 0;
var react_1 = __importDefault(require("react"));
var ButtonGroupItem = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "ButtonGroup__Item" }, children));
};
exports.ButtonGroupItem = ButtonGroupItem;
exports.ButtonGroupItem.displayName = 'ButtonGroupItem';
//# sourceMappingURL=ButtonGroupItem.js.map